import { render } from "./SettingsSilencedWords.vue?vue&type=template&id=5440787f"
import script from "./SettingsSilencedWords.vue?vue&type=script&lang=js"
export * from "./SettingsSilencedWords.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__